import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import * as types from '@reserve/store/types'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import reserveHelper from '@reserve/reserve-helper'

import { EnumCalendarViewType } from '@reserve/types'

import DayView from '@reserve/components/DayView/DayView.vue'
import MergeHeader from '@reserve/components/MergeView/MergeHeader.vue'
import TimeLine from '@reserve/components/MergeView/TimeLine.vue'
import ResourceLine from '@reserve/components/MergeView/ResourceLine.vue'


@Component({
    components: {
        DayView,
        MergeHeader,
        TimeLine,
        ResourceLine
    },

    computed: mapGetters({
        selectedResources: types.SELECTED_RESOURCE_LIST 
    }),

    methods: {
        ...mapActions({
            setViewMode: types.CALENDAR_VIEWMODE,
            loadEvents: types.CALENDAR_DAILY_EVENT_LOAD
        }),

        ...mapMutations({
            setLoading: types.CALENDAR_LOADING
        })
    }
})
export default class MergeView  extends Vue {
    setLoading!: (payload: boolean) => void;
    setViewMode!: (viewType: EnumCalendarViewType) => void;
    loadEvents!: () => Promise<any[]>;

    selectedResources!: reserve.ResourceItemBase[];

    mResrouces: reserve.ResourceItemBase[] = [];

    @Watch('selectedResources')
    onSelectedResourceChanged(newVal: reserve.ResourceItemBase[]) {
        this.setLoading(true);
        this.loadEvents().then(res => {
            this.mResrouces = newVal.filter(r => !reserveHelper.isHeaderType(r.resourceType));           
        }).finally(() => {
            this.setLoading(false);
        })
    }

    created() {
        this.setViewMode(EnumCalendarViewType.Merge);
        this.onSelectedResourceChanged(this.selectedResources);
    }
}